<template>
  <div>
    <div class="container search-customer">
      <div class="input-group mb-4">
        <input
          type="text"
          class="form-control fluid-search"
          placeholder="ค้นหา"
          @keyup="searchAction"
          ref="fluid_search"
        />
        <div class="input-group-prepend">
          <span class="input-group-text icon-search">
            <i class="icon-Search"></i>
          </span>
        </div>
      </div>
    </div>

    <div class="container my-2">
      <span style="color: #003c8f" class="f-20">
        <img src="/img/icons_v2/bx_info-circle.png" alt="icon-info" />
        กรุณาตรวจสอบ การเปิดใช้บริการตำแหน่งที่ตั้ง (Location) ที่อุปกรณ์ของท่าน
      </span>

      <div>
        <span class="f-20">
          ** หากตำแหน่งไม่อัพเดต กรุณาทำการ
          <u class="f-20">เปิด-ปิด ตำแหน่ง (Location)</u>
          อีกครั้ง ณ บริเวณนั้นไม่เกิน 5 Km.
        </span>
      </div>
    </div>

    <div class="scroll-customer">
      <div
        class="container list"
        v-for="(item, index) in listData"
        :key="index"
        @click="toVisitPlanDate(item.customer_id)"
      >
        <div class="d-flex">
          <img :src="item.customer_pic" class="picture-icon" />
          <div class="pl-5 pr-5">
            <div class="box-name">
              <span class="font-w-600 f-20">{{ item.customer_name }}</span>
            </div>
            <div class="d-flex align-items-center">
              <div class="pl-0 pr-2">
                <base-icon-site
                  :data-type="item.name"
                  font-size="20"
                  icon-size="40"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseIconSite from '@/components/v2/ui/BaseIconSite.vue'
export default {
  props: ['toggleDetail', 'listData'],

  components: {
    BaseIconSite,
  },

  methods: {
    activeGread(value) {
      if (value == 'A') {
        return 'active-A'
      } else if (value == 'B') {
        return 'active-B'
      } else if (value == 'C') {
        return 'active-C'
      } else {
        return ''
      }
    },

    toVisitPlanDate(customerId) {
      this.$router.push({ path: `/visitplandate/${customerId}` })
    },

    searchAction() {
      const search = this.$refs.fluid_search.value
      setTimeout(() => {
        this.$emit('search', search)
      }, 250)
    },
  },
}
</script>

<style lang="scss" scoped>
.container.list {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid #cdd8e6;
}
.container.search-customer {
  padding: 25px 20px 0px 20px;
}

.icon-scg {
  background: #f5f5f5 !important;
  width: 100% !important;
  height: 45px !important;
  font-weight: 600;
}

.box-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 550px;
}

.box-status {
  border-radius: 8px;
  color: white;
  padding: 0px 20px;
  margin: 0px 10px;
  &.active-A {
    background-color: red;
  }
  &.active-B {
    background-color: #4a90e2;
  }
  &.active-C {
    background-color: #ffe200;
  }
}

.box-todolist {
  margin: 0px 15px;
  height: 50px;
  padding: 0px 20px;
  border-radius: 5px;
  background-color: #f1f7ff;
  display: flex;
  align-items: center;
  color: #4a90e2;
}

.scroll-customer {
  // margin-top: 20px;
  // max-height: 100%;
  // overflow: scroll;

  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 75vh;
}

.icon-HISTORY-Copy-21:before {
  content: '\e98f';
  color: #4a90e2;
}

.fluid-search {
  height: 70px;
  font-size: 20px;
  background-color: #f6f6f6;
  border: none;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}

.icon-search {
  height: 70px;
  font-size: 20px;
  border: none;
  background-color: #f6f6f6;
  border-top-right-radius: 15px !important;
  border-bottom-right-radius: 15px !important;
}
</style>
